export default __webpack_public_path__ + "static/media/the-report-header.0ec82870.svg";